module.exports = __webpack_public_path__ + "img/diff-1.84a4a9a9.png";